document.addEventListener('DOMContentLoaded', () => {
  const modalAppointment = document.querySelector('.modal--inquired-purchase');
  const btnClose = document.querySelectorAll('.close');
  const btnInquire = document.querySelector('.btn-inquired');
  const messageSuccess = document.querySelector('.message_success.custom-appointment');
  const inputSku = document.querySelector('#ContactForm-sku');

  function getCurrentSku() {
    try {
      const variantDataEl = document.querySelector('#productVariants');
      if (!variantDataEl) {
        return null;
      }

      const variants = JSON.parse(variantDataEl.textContent);
      if (!variants || !variants.length) {
        return null;
      }

      if (variants.length === 1) {
        return variants[0].sku;
      }

      const checkedOptions = Array.from(
        document.querySelectorAll('variant-picker input[type="radio"]:checked')
      ).map((input) => input.value);

      const normalize = (s) => s?.toLowerCase().trim();

      const currentVariant = variants.find((v) => {
        if (!v.options) return false;
        return v.options.every((opt, i) => normalize(opt) === normalize(checkedOptions[i]));
      });

      return currentVariant ? currentVariant.sku : null;
    } catch (err) {
      console.error('Error reading SKU:', err);
      return null;
    }
  }

  function updateSkuField() {
    const sku = getCurrentSku();
    if (sku && inputSku) {
      inputSku.value = sku;
    } else {
      console.warn('⚠️ SKU not found.');
    }
  }

  updateSkuField();

  document.addEventListener('change', (e) => {
    if (e.target.matches('variant-picker input[type="radio"]')) {
      updateSkuField();
    }
  });

  if (btnInquire && modalAppointment) {
    btnInquire.addEventListener('click', (event) => {
      event.preventDefault();
      modalAppointment.style.display = 'block';
      modalAppointment.classList.add('is-active');
      setTimeout(updateSkuField, 300);
    });
  }

  btnClose.forEach((item) => {
    item.addEventListener('click', (event) => {
      event.preventDefault();
      if (modalAppointment) {
        modalAppointment.style.display = 'none';
        modalAppointment.classList.remove('is-active');
      }
    });
  });

  window.addEventListener('click', (event) => {
    if (event.target === modalAppointment) {
      modalAppointment.style.display = 'none';
      modalAppointment.classList.remove('is-active');
    }
  });

  if (window.jQuery) {
    const number = $('#ContactForm-phone');
    number.keyup(function () {
      $(this).val(this.value.replace(/\D/g, ''));
    });
  }

  if (window.location.search.includes('?contact_posted=true') && messageSuccess) {
    messageSuccess.style.display = 'block';
    window.addEventListener('click', () => {
      window.location = location.pathname;
    });
  }

  window.showMessage = function (idSelector) {
    const messageElement = document.getElementById(idSelector);
    if (!sessionStorage.getItem(idSelector)) {
      messageElement.style.display = 'block';
      sessionStorage.setItem(idSelector, true);
      setTimeout(() => {
        messageElement.style.display = 'none';
        sessionStorage.removeItem(idSelector);
      }, 5000);
    }
  };
});
